import { Chip, emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { RegistrationInvitationSource } from '../../../../../../../DiscoveryStore/Types';
import { T } from '../../../../../../../Translations';

interface Props {
  source: RegistrationInvitationSource;
}

function Source({ source }: Props) {
  switch (source) {
    case 'direct-enrollment':
    case 'new-program-family-shared-open-enrollment':
    case 'program-family-shared-open-enrollment':
    case 'open-enrollment':
    case 'preview-only':
    case 'shared-open-enrollment':
    case 'group-membership':
      return emptyFragment();
    case 'coach-recommended':
      return (
        <Chip
          className="uppercase"
          size="sm"
          color="blue"
          radius="sm"
          data-intercom-target="discovery-portal-coach-recommended"
        >
          <T kind="Coach Recommended" />
        </Chip>
      );
  }
}

export default observer(Source);
